import { useQuery } from "@tanstack/react-query";
import { rescheduleKeys } from "../reschedule.keys";
import { rescheduleApi } from "../service";

export function useRescheduleCount() {
  const { data } = useQuery({
    queryKey: rescheduleKeys.count(),
    queryFn: () => rescheduleApi.count().then((r) => r.data),
    refetchInterval: 10_000,
    refetchOnWindowFocus: true,
  });
  return data?.count ?? 0;
}
